import Gauge from "../../../charts/Gauge/Gauge";
import React from "react";
import { UnityGaugeBoxProps } from "./domain/types";

const GaugeBox: React.FC<UnityGaugeBoxProps> = ({ data, name, largest }) => {
  if (largest) {
    return <Gauge data={data} name={name} gaugeType={"large"} />;
  } else {
    return <Gauge data={data} name={name} gaugeType={"wide"} />;
  }
};

export default GaugeBox;